
import {Component, Vue} from 'vue-property-decorator'
import {apiArticleCategoryAdd, apiArticleCategoryDetail, apiArticleCategoryEdit, apiShopLists} from '@/api/shop'
import {debounce} from '@/utils/util'

@Component({
  components: {}
})
export default class ArticleCategoryEdit extends Vue {
  identity: number | null = null;
  shopData: any[] = []
  form: any = {
    sid: '',
    name: '',
    is_show: 1,
    sort: 0
  };

  rules = {
    sid: [{required: true, message: '请选择商户', trigger: ['blur', 'change']}],
    name: [{required: true, message: '请输入分类名称', trigger: ['blur', 'change']}],
    is_show: [{required: true, message: '请选择是否显示', trigger: ['blur', 'change']}],
    sort: [{required: true, message: '请输入排序', trigger: ['blur', 'change']}],
  };

  onSubmit(formName: string) {
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      if (!this.identity) {
        this.handleAdd()
      } else {
        this.handleEdit()
      }
    })
  }

  async handleAdd(): Promise<void> {
    await apiArticleCategoryAdd({...this.form})
    setTimeout(() => this.$router.go(-1), 500)
  }

  async handleEdit(): Promise<void> {
    await apiArticleCategoryEdit({...this.form, id: this.identity})
    setTimeout(() => this.$router.go(-1), 500)
  }

  async getDetailFunc(): Promise<void> {
    const res = await apiArticleCategoryDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }

  async getShopListsFn(): Promise<void> {
    const res: any = await apiShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.lists;
  }

  created() {
    const query: any = this.$route.query
    this.identity = +query.id
    if (+query.id) {
      this.getDetailFunc()
    }
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)
  }
}
